import React from 'react';

import Carousel from 'react-slick';

import type { TSailingPortDetail } from '@/infra/types/voyageInfo/port';

import UIResource from '@/components/UIResource';

import Item from './Item';

import './ItineraryList.scss';

type itineraryListProps = {
  carousel?: unknown;
  itinerary?: TSailingPortDetail[];
  onItemClick?: () => void;
};

const ItineraryList = ({ carousel, itinerary, onItemClick }: itineraryListProps) => {
  const Component = carousel ? Carousel : 'ul';
  const Child = carousel ? 'div' : 'li';

  return (
    <Component className="ItineraryListNew">
      <Child className="ItineraryListNew__header">
        <div className="ItineraryListNew__dayHeader">
          <UIResource id="ItineraryDetail.Day" />
        </div>
        <div className="ItineraryListNew__portHeader">
          <UIResource id="ItineraryDetail.Port" />
        </div>
      </Child>
      {itinerary &&
        itinerary.map((item, index) => {
          return (
            <Item
              component={Child}
              index={index}
              itinerary={item}
              key={`${item.dayType}-${item.itineraryDay}`}
              lastItem={index - 1 === itinerary.length}
              onClick={onItemClick}
            />
          );
        })}
    </Component>
  );
};

export default ItineraryList;
